// LA Muscle Tabs — class toggle, no hash scrolling
(function () {
  function activate(group, id) {
    const tabs   = Array.from(group.querySelectorAll('.lam-tabs__button'));
    const panels = Array.from(group.querySelectorAll('.lam-tabs__panel'));

    tabs.forEach(t => t.classList.toggle('is-active', t.dataset.target === id));
    panels.forEach(p => p.classList.toggle('is-active', p.id === id));
  }

  function init(group) {
    if (group.__lamTabsReady) return;
    group.__lamTabsReady = true;

    const tabs = Array.from(group.querySelectorAll('.lam-tabs__button'));
    if (!tabs.length) return;

    // Initial: first tab active, unless one is pre-marked via data-initial
    const initial = tabs.find(t => t.hasAttribute('data-initial')) || tabs[0];
    activate(group, initial.dataset.target);

    // Clicks: prevent hash jump, toggle classes
    group.querySelector('.lam-tabs__list').addEventListener('click', (e) => {
      const tab = e.target.closest('.lam-tabs__button');
      if (!tab) return;
      e.preventDefault(); // stop the page from jumping
      activate(group, tab.dataset.target);
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('.lam-tabs').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  // For Shopify section renders
  document.addEventListener('shopify:section:load', e => boot(e.target || document));
})();




